import "./Footer.css";
import instagramIcon from "../../assets/svg/instagram.svg";
import { useRef } from "react";

function Footer() {
  const instaRef = useRef();

  const instagramUrl = 'https://www.instagram.com/filefreak.io?igsh=MTVlNmIxZjlzZTRhdQ%3D%3D&utm_source=qr'

  return (
    <footer className="site-footer">
      <nav>
        {/* contact info */}
        <div className="contact">
          <a href="mailto:support@filefreak.io?subject=Support%20Request&body=Hi%20FileFreak%20Team,">support@filefreak.io</a>
          <p>945 Stuyvesant Ave, Union NJ 07083</p>
        </div>

        {/* privacy info */}
        <div className="privacy">
          <div className="flex-center privacy-links">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms of Service</a>
          </div>
          <p>© 2025 FileFreak LLC. All rights reserved.</p>
        </div>

        {/* social media links */}
        <div className="social">
          <button className="social-link" onClick={() => window.open(instagramUrl, '__blank')}>
            <a href={instagramUrl} target="__blank">
              Follow Us on Instagram
            </a>
            <img ref={instaRef} src={instagramIcon} alt="instagram social link" />
          </button>
        </div>
      </nav>
    </footer>
  );
}

export default Footer;
